import { exists } from '@engine/lib/utility/exists'; // LEGACY CODE

var Sortable = require('sortablejs');

function riskFiltersIds() {
  var riskFilterInputs = $('.risk-filters input');
  var riskFiltersIdsArray = Array.prototype.map.call(riskFilterInputs, function (filterInput) {
    return filterInput.value;
  });
  return riskFiltersIdsArray;
}

function listenForSort() {
  if (!exists($('.risk-filters.sortable'))) {
    return;
  }

  var sortableRiskFilters = document.getElementById('sortable-risk-filters');
  var sortingMessage = $('.sorting');
  var sortingCompletedMessage = $('.sorting-completed');
  var sortURL = location.pathname.replace('/edit', '') + '/risk_filters/sort';
  Sortable.create(sortableRiskFilters, {
    animation: 150,
    onEnd: function onEnd() {
      var riskFiltersIdsInArray = riskFiltersIds();
      $.ajax({
        method: 'POST',
        url: sortURL,
        data: {
          risk_filter: riskFiltersIdsInArray
        },
        beforeSend: function beforeSend() {
          sortingCompletedMessage.addClass('hide');
          sortingMessage.removeClass('hide');
        },
        success: function success() {
          sortingMessage.addClass('hide');
          sortingCompletedMessage.removeClass('hide');
        }
      });
    }
  });
}

function listenForBulkDelete() {
  $(document).on('submit', '#risk-filters-form', function (e) {
    e.preventDefault();

    if (confirm(I18n.t('javascript.delete_risk_filters_confirmation'))) {
      $.ajax({
        url: $(this).attr('action'),
        method: 'POST',
        data: $(this).serialize(),
        success: function success(data) {
          var html = $(data).find('#risk_filters').html();
          $('#risk_filters').html(html);
        }
      });
    }
  });
}

function listenForDelete() {
  $('#risk_filters').on('click', '[id^=remove_risk_filter_]', function (e) {
    e.preventDefault();
    var filter_name = $(this).data('filter-name');

    if (confirm(I18n.t('javascript.delete_risk_filter_confirmation', {
      filter: filter_name
    }))) {
      $.ajax({
        url: $(this).attr('href'),
        method: 'DELETE'
      }).done(function (data) {
        $('#risk_filters').html($(data).find('#risk_filters').html());
        listenForSort();
      });
    }
  });
}

function listenForBtnToolbarClick() {
  var css_selectors = '.risk-filters .btn-toolbar input, .risk-filters .btn-toolbar .btn';
  $('#risk_filters').on('click', css_selectors, function (e) {
    e.stopPropagation();
  });
}

var RiskFilters = {
  listenForDelete: listenForDelete,
  listenForBulkDelete: listenForBulkDelete,
  listenForSort: listenForSort,
  listenForBtnToolbarClick: listenForBtnToolbarClick
};
export default RiskFilters;